import React, { useEffect, useState } from 'react'
import { useOrderStore } from 'src/hooks/order';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';
import { useSystem } from "src/hooks/system";

const OrderHistoryCancellationPopup = (props) => {
    const { SetStatus, data: { selected_fields } } = props;
    const [{ order_detail }, { }, { order_cancellation_email }] = useOrderStore();
    const { numericPattern, currencyType: { USD } } = Constants;

    let initialState = {
        cancellationReason: '',
        phoneNumber: ''
    }

    const [orderItems, setOrderItems] = useState([])
    const [detailValidation, setDetailValidation] = useState({})
    const [cancellationDetail, setCancellationDetail] = useState(initialState)
    const [checkbox, setCheckbox] = useState(false)
    const [loading, setLoading] = useState(false)
    const [,{ get_quantity_format }] = useSystem();

    useEffect(() => {
        setOrderItems(Object.values(selected_fields))
    }, [selected_fields])

    const onchangeCheckbox = (e) => {
        setCheckbox(e.target.checked)
        if(e.target.checked) {
            const valid = onValidateData()
        }
    }

    const onDataChange = (field, value) => {
        setCheckbox(false)
        if (detailValidation && Object.keys(detailValidation).length > 0) {
            delete detailValidation[field];
        }

        if(field === 'reason') {
            cancellationDetail['otherReason'] = "";
            delete detailValidation['otherReason'];
        }

        setCancellationDetail({ ...cancellationDetail, [field]: value });
    };

    const onValidateData = async () => {
        let validationModal = {};
      
        if (!Helper.valueIsNotNull(cancellationDetail.reason)) {
            validationModal.reason = "Please Select Cancellation Reason";
        }
        if (Helper.valueIsNotNull(cancellationDetail.reason) && cancellationDetail.reason === 'Other' && (!Helper.valueIsNotNull(cancellationDetail.otherReason))) {
            validationModal.otherReason = "Please Enter Cancellation Reason";
        }
        if (!Helper.valueIsNotNull(cancellationDetail.phoneNumber)) {
          validationModal.phoneNumber = "Please Enter Phone Number";
        }
        if (Helper.valueIsNotNull(cancellationDetail.phoneNumber) && (!Helper.validateRegex(cancellationDetail.phoneNumber, numericPattern))) {
            validationModal.phoneNumber = "Please Enter Valid Phone Number";
        }

        setDetailValidation(validationModal);
        return Object.keys(validationModal).length === 0;
    }

    const renderAddress = (address) => {
        if (address) {
            return (
                <div>
                    <p>
                        {Helper.valueIsNotNull(address?.address1) && address?.address1}
                        {Helper.valueIsNotNull(address?.address2) && address?.address2}<br />
                        {Helper.valueIsNotNull(address?.city) && address?.city + ", "} 
                        {Helper.valueIsNotNull(address?.stateName) && address?.stateName + " "}
                        {Helper.valueIsNotNull(address?.postalCode) && address?.postalCode}<br />
                        {Helper.valueIsNotNull(address?.countryName) && address?.countryName}
                    </p>
                </div>
            )
        } else { return <></> }
    };

    const handleSubmit= async () => {
        setLoading(true)
        const shippingAddress = order_detail?.shipTo?.address
        const billingAddress = order_detail?.billTo?.address
        
        let cancellationIteamList= []

        for (let i = 0; i < orderItems?.length; i++) {
            cancellationIteamList.push({
                "quantity": orderItems[i]?.quantity,
                "productName": orderItems[i]?.manufacturerPartNumber,
                "customerPart": orderItems[i]?.customerPartNumber,
                "unitPrice": orderItems[i]?.unitPrice,
                "currency": USD,
              })
        }

        const payload = {
            "webOrderNumber": order_detail?.webOrderNumber,
            "customerPONumber": order_detail?.poNumber,
            "salesNumber": order_detail?.salesOrderNumber,
            "orderDate": Helper.convertOrderModuleDateFormat(order_detail.orderDate),
            "orderType": order_detail.orderType,
            "accountNumber": order_detail?.accountNo,
            "shippingAddress": {
                "address1": shippingAddress?.address1,
                "address2": shippingAddress?.address2,
                "city": shippingAddress?.city,
                "state": shippingAddress?.stateName,
                "postalCode": shippingAddress?.postalCode,
                "country": shippingAddress?.countryName
            },
            "billingAddress": {
                "address1": billingAddress?.address1,
                "address2": billingAddress?.address2,
                "city": billingAddress?.city,
                "state": billingAddress?.stateName,
                "postalCode": billingAddress?.postalCode,
                "country": billingAddress?.countryName
            },
            "cancellationReason": cancellationDetail.reason,
            "cancellationReasonMessage": cancellationDetail.otherReason,
            "phoneNumber": cancellationDetail?.phoneNumber,
            "cancellationIteamList": cancellationIteamList,
            "currency": USD,
            "cancellationDateAndTime": Helper.convertOrderModuleDateFormat(new Date()),
            "userInformation": {
              "userName": order_detail?.buyerInfo?.name,
              "emailAddress": order_detail?.buyerInfo?.address?.emailId,
              "contactNumber": order_detail?.buyerInfo?.address?.phoneNo
            }
        }
    
        const res = await order_cancellation_email(payload)
        if(res) {
            SetStatus(false)
        }
        setLoading(false)
    }

    const getOrderType = (type) => {
        return type === "OffLine" ? "Offline" : "Online"
    }

    return (
        <>
            <div className="avnet-modal modal-800 cancellation-request">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="modal-title m-auto">Cancellation Request</h3>
                    </div>

                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <p className='font-13 font-arial text-center mb-0'><strong>{Helper.convertOrderModuleDateFormat(new Date())}</strong></p>
                        <p className='font-13 font-arial text-center mb-4'>Please fill out the form below in order to request a cancellation.</p>
                        <div className='cancellation-order-part'>
                            <div className='bs5 row'>
                                <div className='col-3'>
                                    <div className='font-13 font-arial'>
                                        <strong>PO Number</strong>
                                        <p className='font-13 font-arial'>{order_detail?.poNumber && order_detail?.poNumber.trim() !== '' ? order_detail?.poNumber : '-'}</p>
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div className='font-13 font-arial'>
                                        <strong>Web Order Number</strong>
                                        <p className='font-13 font-arial'>{order_detail?.webOrderNumber && order_detail?.webOrderNumber.trim() !== '' ? order_detail?.webOrderNumber : '-'}</p>
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div className='font-13 font-arial'>
                                        <strong>Sales Order Number</strong>
                                        <p className='font-13 font-arial'>{order_detail?.salesOrderNumber && order_detail?.salesOrderNumber.trim() !== '' ? order_detail?.salesOrderNumber : '-'}</p>
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div className='font-13 font-arial'>
                                        <strong>Account  Number</strong>
                                        <p className='font-13 font-arial'>{order_detail?.accountNo && order_detail?.accountNo.trim() !== '' ? order_detail?.accountNo : '-'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <table className='table table-bordered border-1 mb-4'>
                            <thead>
                                <tr class="bg-grey">
                                    <th>ITEM</th>
                                    <th>PART INFORMATION</th>
                                    <th>PRICE</th>
                                    <th>QUANTITY</th>
                                    <th>ORDER DATE</th>
                                    <th>ORDER TYPE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderItems?.length > 0 && orderItems?.map((val, i) => {
                                    return <tr key={i}>
                                            <td>{val.itemNo}</td>
                                            <td>
                                                {val?.orderItemNumber && val.manufacturerPartNumber ?
                                                    <NavigateToProductDetail target="_blank" data={{ SEOManufacturerName: val?.SEOManufacturerName, SEOERPMFRPartNumber: val?.SEOERPMFRPartNumber, ItemNumber: val?.orderItemNumber, ERPPartNumber: val?.sapMaterialNo }}>
                                                        <span className="text-nowrap text-blue2">{val.manufacturerPartNumber ? val.manufacturerPartNumber : ''}</span>
                                                    </NavigateToProductDetail> :  
                                                    <span className="text-nowrap">{val.manufacturerPartNumber ? val.manufacturerPartNumber : ''}</span>
                                                }
                                                <p>{val.manufacturerPartDesc}</p>
                                            </td>
                                            <td>
                                                <strong> UNIT: </strong>{val.unitPrice ? System.getFormatNumber({ amount: Number(val.unitPrice), currency: USD}) : ''}<br />
                                                <strong> Total: </strong> {val.totalLinePrice ? System.getFormatNumber({ amount: Number(val.totalLinePrice), currency: USD}) : ''}
                                            </td>
                                            <td>{(val.orderQuantity || val.quantity) ? get_quantity_format(Number(val.orderQuantity || val.quantity)) : ''}</td>
                                            <td>{order_detail.orderDate ? Helper.convertDateFormatToMMDDYYYY(order_detail.orderDate) : '-'}</td>
                                            <td>{val.orderType ? getOrderType(val.orderType) : ''}</td>
                                        </tr>
                                })}
                            </tbody>
                        </table>

                        <div className='bs5 row mb-5'>
                            <div className='col-4'>
                                <label for="" class="d-block">Cancellation Reason*</label>
                                <div className='selectbox'>
                                    <select 
                                        className={`form-control form-control-sm ${detailValidation.reason ? "error" : ""}`}
                                        aria-label="Default select example" 
                                        value={cancellationDetail.reason}
                                        onChange={({ target: { value } }) => onDataChange("reason", value)}
                                    >
                                        <option value="">Select Cancellation Reason</option>
                                        <option value="CustomerNoLongerRequires">Customer no longer requires</option>
                                        <option value="DuplicateQuoteOrder">Duplicate quote/Order</option>
                                        <option value="WrongInformation">Wrong information</option>
                                        <option value="ServiceCancellation">Service Cancellation</option>
                                        <option value="OrderedWrongParts">Ordered wrong parts</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                {detailValidation.reason && <p className="error">{detailValidation.reason}</p>}
                            </div>
                            <div className='col-8 addmultiplepart'>
                            {cancellationDetail.reason === 'Other' && 
                            <>
                                <label for="" class="d-block">Others:*</label>
                                <textarea
                                    maxLength={500}
                                    onChange={({ target: { value } }) => onDataChange("otherReason", value)} 
                                    className={`form-control create-part-textarea ${detailValidation.otherReason ? "error" : ""}`} 
                                    placeholder="Other Reason" name="Other Reason" 
                                    value={cancellationDetail.otherReason} />
                                {detailValidation.otherReason && <p className="error">{detailValidation.otherReason}</p>}
                            </>}
                            </div>
                        </div>

                        <div className='bs5 row'>
                            <div className='col-4 mb-3'>
                                <div className='font-13 font-arial'>
                                    <p><strong>CONTACT INFORMATION:</strong></p>
                                    <div className='font-13 font-arial'><strong>Name:</strong></div>
                                    <p className='font-13 font-arial'>{order_detail?.buyerInfo?.name}</p>
                                    <div className='font-13 font-arial'><strong>Email:</strong></div>
                                    <p className='font-13 font-arial'>{order_detail?.buyerInfo?.address?.emailId}</p>
                                </div>
                            </div>
                            <div className='col-4 mb-3'>
                                <div className='font-13 font-arial'>
                                    <div className='mb-2'><strong>SHIPPING ADDRESS:</strong></div>
                                    {renderAddress(order_detail?.shipTo?.address)}
                                </div>
                            </div>
                            <div className='col-4 mb-3'>
                                <div className='font-13 font-arial'>
                                <div className='mb-2'><strong>BILLING ADDRESS:</strong></div>
                                    {renderAddress(order_detail?.billTo?.address)}
                                </div>
                            </div>
                        </div>

                        <div className='mb-4 maxw240'>
                            <div className='form-group'>
                                <label for="" class="d-block">Phone Number*</label>
                                <input type="text"
                                    className={`form-control form-control-sm ${detailValidation.phoneNumber ? "error" : ""}`}
                                    placeholder="Phone Number"
                                    name="Phone Number"
                                    value={cancellationDetail.phoneNumber}
                                    onChange={({ target: { value } }) => {
                                        const filteredValue = value.replace(/[^\d()+\-\/\s]/g, ''); // Only allowed characters
                                        onDataChange("phoneNumber", filteredValue)
                                    }}
                                    maxLength={20} />
                                {detailValidation.phoneNumber && <p className="error">{detailValidation.phoneNumber}</p>}
                            </div>
                        </div>

                        <div class="d-flex align-items-center text-black">
                            <input type="checkbox" class="form-check-input mt-0 me-2" id="customCheck1" name="" checked={checkbox} onChange={(e) => onchangeCheckbox(e)} />
                            <label for="customCheck1" class="cursor-pointer mb-0">By checking this box, I acknowledge this is a cancellation request and a cancellation of the order is not guaranteed.</label>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center mt-4 d-flex">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={() => {
                                SetStatus(false)
                            }}>
                                CLOSE
                            </button>
                            <button type="button" 
                                className="bs5 btn btn-primary btn-sm w145" 
                                disabled={Object.keys(detailValidation).length === 0 && checkbox ? false : true}
                                onClick={handleSubmit}>
                                {loading ?
                                    <i className="fa fa-spinner fa-spin" /> :
                                    "send"
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderHistoryCancellationPopup